import Request from './baseRequest'

const backend = () => window.config.VUE_APP_BACKEND
const authConfig = () => {
	const token = JSON.parse(localStorage.getItem('auth.currentUser')).token
	return { headers: { authorization: `Bearer ${token}` } }
}
const project = () => sessionStorage.getItem('current_project')
const qs = (params = {}) => {
	const search = new URLSearchParams()
	Object.entries(params).forEach(([key, value]) => {
		if (value !== undefined && value !== null && value !== '') search.append(key, value)
	})
	const query = search.toString()
	return query ? `?${query}` : ''
}

// ---- goals ---------------------------------------------------------------
const _getGoals = (params = {}) =>
	Request.get(`${backend()}/api/gopersonal-auto-goals${qs({ project: project(), ...params })}`, authConfig())
const _getGoal = (goalId) => Request.get(`${backend()}/api/gopersonal-auto-goals/${goalId}`, authConfig())
const _createGoal = (goal) => Request.post(`${backend()}/api/gopersonal-auto-goals`, { ...goal, project: project() }, authConfig())
const _updateGoal = (goal) => Request.put(`${backend()}/api/gopersonal-auto-goals/${goal._id}`, goal, authConfig())
const _deleteGoal = (goalId) => Request.delete(`${backend()}/api/gopersonal-auto-goals/${goalId}`, authConfig())
const _runGoal = (goalId) => Request.post(`${backend()}/api/gopersonal-auto-goals/${goalId}/run`, {}, authConfig())
const _pauseGoal = (goalId) => Request.post(`${backend()}/api/gopersonal-auto-goals/${goalId}/pause`, {}, authConfig())
const _resumeGoal = (goalId) => Request.post(`${backend()}/api/gopersonal-auto-goals/${goalId}/resume`, {}, authConfig())
const _getGoalMetrics = (goalId, params = {}) =>
	Request.get(`${backend()}/api/gopersonal-auto-goals/${goalId}/metrics${qs(params)}`, authConfig())
const _getGoalSummary = (goalId) => Request.get(`${backend()}/api/gopersonal-auto-goals/${goalId}/summary`, authConfig())
const _getGoalLimits = () => Request.get(`${backend()}/api/gopersonal-auto-goals/limits${qs({ project: project() })}`, authConfig())

// ---- runs (bitácora) -----------------------------------------------------
const _getRuns = (params = {}) =>
	Request.get(`${backend()}/api/gopersonal-auto-runs${qs({ project: project(), ...params })}`, authConfig())
const _getRun = (runId) => Request.get(`${backend()}/api/gopersonal-auto-runs/${runId}`, authConfig())
const _cancelRun = (runId, reason) => Request.post(`${backend()}/api/gopersonal-auto-runs/${runId}/cancel`, { reason }, authConfig())

// ---- proposals -----------------------------------------------------------
const _getProposals = (params = {}) =>
	Request.get(`${backend()}/api/gopersonal-auto-proposals${qs({ project: project(), ...params })}`, authConfig())
const _approveProposal = (proposalId, comment) =>
	Request.post(`${backend()}/api/gopersonal-auto-proposals/${proposalId}/approve`, { comment }, authConfig())
const _rejectProposal = (proposalId, comment) =>
	Request.post(`${backend()}/api/gopersonal-auto-proposals/${proposalId}/reject`, { comment }, authConfig())
const _markDoneProposal = (proposalId, comment) =>
	Request.post(`${backend()}/api/gopersonal-auto-proposals/${proposalId}/done`, { comment }, authConfig())
const _requestProposalApproval = (proposalId, { to, message }) =>
	Request.post(`${backend()}/api/gopersonal-auto-proposals/${proposalId}/request-approval`, { to, message }, authConfig())

// ---- actions & A/B -------------------------------------------------------
const _getActions = (params = {}) =>
	Request.get(`${backend()}/api/gopersonal-auto-actions${qs({ project: project(), ...params })}`, authConfig())
const _getActionLevels = () => Request.get(`${backend()}/api/gopersonal-auto-actions/levels`, authConfig())
const _getAbTests = (params = {}) =>
	Request.get(`${backend()}/api/gopersonal-auto/ab-tests${qs({ project: project(), ...params })}`, authConfig())

// ---- helpers for the goal form ------------------------------------------
const _getProject = () => Request.get(`${backend()}/api/projects/${project()}`, authConfig())
const _getProjectContents = () =>
	Request.get(
		`${backend()}/api/contents?whereObj=${encodeURIComponent(JSON.stringify({ project: project() }))}&select=${encodeURIComponent('name key pageType status')}&limit=500`,
		authConfig()
	)

export default {
	getGoals: _getGoals,
	getGoal: _getGoal,
	createGoal: _createGoal,
	updateGoal: _updateGoal,
	deleteGoal: _deleteGoal,
	runGoal: _runGoal,
	pauseGoal: _pauseGoal,
	resumeGoal: _resumeGoal,
	getGoalMetrics: _getGoalMetrics,
	getGoalSummary: _getGoalSummary,
	getGoalLimits: _getGoalLimits,
	getRuns: _getRuns,
	getRun: _getRun,
	cancelRun: _cancelRun,
	getProposals: _getProposals,
	approveProposal: _approveProposal,
	markDoneProposal: _markDoneProposal,
	rejectProposal: _rejectProposal,
	requestProposalApproval: _requestProposalApproval,
	getActions: _getActions,
	getActionLevels: _getActionLevels,
	getAbTests: _getAbTests,
	getProjectContents: _getProjectContents,
	getProject: _getProject
}
